import { render, staticRenderFns } from "./WeekPicker.vue?vue&type=template&id=afc71982&scoped=true"
import script from "./WeekPicker.vue?vue&type=script&lang=js"
export * from "./WeekPicker.vue?vue&type=script&lang=js"
import style0 from "./WeekPicker.vue?vue&type=style&index=0&id=afc71982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc71982",
  null
  
)

export default component.exports